import script from "./policy-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./policy-modal.vue?vue&type=script&setup=true&lang=js"

import "./policy-modal.vue?vue&type=style&index=0&id=379f7662&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-379f7662"]])

export default __exports__